import { render, staticRenderFns } from "./ProductSelection.vue?vue&type=template&id=3347efc1&scoped=true"
import script from "./ProductSelection.vue?vue&type=script&lang=js"
export * from "./ProductSelection.vue?vue&type=script&lang=js"
import style0 from "./ProductSelection.vue?vue&type=style&index=0&id=3347efc1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3347efc1",
  null
  
)

export default component.exports